import React from 'react';

import ConceptSection from './ConceptSection';
import OriginalConceptChart from '../charts/OriginalConceptChart';

function OriginalSection({ selectedConcept, isGlobalPercentageEnabled }) {
  return (
    <ConceptSection selectedConcept={selectedConcept} isGlobalPercentageEnabled={isGlobalPercentageEnabled}>
      {({ compareConcepts, isGlobalPercentage }) => (
        <OriginalConceptChart
          compareConcepts={compareConcepts}
          selectedConcept={selectedConcept}
          isGlobalPercentage={isGlobalPercentage}
        />
      )}
    </ConceptSection>
  );
}

export default OriginalSection;
